import { IUpgradeGains, IUpgradeGainsWeapon } from "@/data/types";
import pluralize from "pluralize";
import { isItem, isWeapon, pluralizeWrap } from "./Helpers";
import RulesService from "./rules/RulesService";

export default class EquipmentService {
  public static compareEquipment(hasItem: IUpgradeGains, searchItem: string): boolean {
    // "replace [nothing] -> always ok"
    if (!searchItem) return true;

    // otherwise match by name
    return (
      this.compareEquipmentNames(hasItem.name, searchItem) ||
      this.compareEquipmentNames(hasItem.label, searchItem)
    );
  }

  public static compareEquipmentNames(hasItem: string, searchItem: string): boolean {
    const find = searchItem?.toLowerCase().trim();
    const aSingle = pluralize.singular(hasItem?.toLowerCase() || "");
    const bSingle = pluralize.singular(find || "");
    return aSingle === bSingle;
  }

  public static contains(equipment: IUpgradeGains[], target: string) {
    return equipment.some((x) => this.compareEquipment(x, target));
  }

  static getAP(e: IUpgradeGainsWeapon): number {
    if (!e || !e.specialRules) return null;

    const ap = e.specialRules.find((r) => r.name === "AP");
    return ap ? parseInt(ap.rating) : null;
  }

  static formatString(eqp: IUpgradeGains): string {
    try {
      const parts = [];
      const name = pluralizeWrap(eqp.name ?? eqp.label, eqp.count || 1);
      if (isWeapon(eqp)) {
        parts.push(eqp.range ? `${eqp.range}"` : null);
        parts.push(`A${eqp.attacks}`);
        parts.push(...(eqp.specialRules?.map((r) => RulesService.displayName(r)) ?? []));
      }

      if (isItem(eqp)) {
        parts.push(...eqp.content.map((c) => this.formatString(c)));
      }

      const displayParts = parts.filter((m) => !!m);

      return displayParts.length > 0 ? `${name} (${displayParts.join(", ")})` : name; // comma separated list
    } catch (e) {
      console.error(e, eqp);
    }
  }
}
